import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//outsource
import moment from "moment";
import { Row, Col, Button, Tooltip, Space, message, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../../store/var/var.action";
import { setDateLabel } from "../../../store/var/var.action";
import { dateSelector } from "../../../store/var/var.selector";
import { userSelector } from "../../../store/user/user.selector";
import { labelDateSelector } from "../../../store/var/var.selector";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import SelectStaff from "./component/select_staff";
import DialogDateSelect from "../dialog/dialog_date_select";
//components

const IncomeStaffTopBar = (props) => {
  // -------------------------- VAR --------------------------
  const { data, block, edit, handleAddRow } = props;
  // -------------------------- STATE --------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const date = useSelector(dateSelector);
  const label = useSelector(labelDateSelector);
  const user = useSelector(userSelector);

  const userId = user?.id;

  // -------------------------- FUNCTION -----------------------
  const openDialog = () => {
    setOpen(true);
  };

  const handleNextDate = () => {
    if (date) {
      let target = date || moment();
      const next = target?.add(1, "day");
      dispatch(setDate({ data: next }));
      dispatch(setDateLabel({ data: next?.format("DD/MM/YYYY") }));
    }
  };

  const handlepreviousDate = () => {
    if (date) {
      let target = date || moment();
      const prev = target?.subtract(1, "day");
      dispatch(setDate({ data: prev }));
      dispatch(setDateLabel({ data: prev?.format("DD/MM/YYYY") }));
    }
  };

  const renderBlocked = (data, userId) => {
    let userList = data?.map((item) => item?.userId);
    let blocked = userList?.includes(userId) || null;
    return blocked;
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderControlDate = () => {
    return (
      <Space>
        {renderLeft()}
        {renderButton()}
        {renderRight()}
      </Space>
    );
  };

  const renderLeft = () => {
    return (
      <Tooltip title="previous Date">
        <Button
          onClick={handlepreviousDate}
          type="text"
          icon={<LeftOutlined />}
          disabled={true}
        />
      </Tooltip>
    );
  };

  const renderRight = () => {
    const disabled =
      date?.format("DD/MM/YYYY") === moment()?.format("DD/MM/YYYY")
        ? true
        : false;

    return (
      <Tooltip title="Next Date">
        <Button
          // disabled={disabled}
          disabled={true}
          onClick={handleNextDate}
          type="text"
          icon={<RightOutlined />}
        />
      </Tooltip>
    );
  };

  const renderButton = () => {
    return (
      <Button
        onClick={openDialog}
        icon={<CalendarOutlined style={{ color: "gray" }} />}
        disabled={true}
      >
        {label}
      </Button>
    );
  };

  const renderConfirmBtn = () => {
    const color = block ? "#f50" : "orange";
    let editLabel = block ? "Locked" : "To be confirmed";
    return <Tag color={color}>{editLabel}</Tag>;
  };

  const renderDialog = () => {
    return <DialogDateSelect open={open} setOpen={setOpen} />;
  };

  const renderAddStaff = () => {
    const blocked = renderBlocked(data, userId);
    return (
      <SelectStaff
        edit={edit}
        blocked={blocked}
        block={block}
        data={data}
        handleAddRow={handleAddRow}
      />
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row style={{ width: "100%" }} align="middle">
      <Col flex="200px">{renderAddStaff()}</Col>
      <Col align="center" flex="auto">
        {renderControlDate()}
      </Col>
      <Col align="right" flex="200px">
        {renderConfirmBtn()}
      </Col>
      {renderDialog()}
    </Row>
  );
};

export default IncomeStaffTopBar;
